import {mapGetters} from 'vuex';

export default{
    name: 'mvtCollapse',
    computed: {
        ...mapGetters('glb', ['glb'])
    },
    props: {
        isActive: {
            type: Boolean,
            default: false
        },
        disable: {
            type: Boolean,
            default:false
        }
    },
    data(){
        return {
            active: this.disable ? true : this.isActive,
        };
    },
    methods: {
        open(){
            if(!this.active){
                this.active = true;
                this.$emit('open');
            }
        },
        close(){
            if(this.active){
                this.active = false;
                this.$emit('close');
            }
        },
        toggle(){
            if(this.active){
                this.close();
            }else{
                this.open();
            }
        }
    }
}